<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-md-4 left">
          <div class="title">
            {{ $t('sidebar.salesummary') }}
            <template v-if="ready">
              >
              {{ posSession.ps_code }}
            </template>
          </div>
        </div>
        <div
          v-if="ready"
          class="col-md-8 right">
          <div class="action">
            <base-dropdown-filter-download
              :items="DOWNLOAD_EXTS"
              :loading="false"
              @onSelect="handleSelectDownload"
            />
            <!-- status button -->
            <div
              v-if="(posSession.status == 'selling' || posSession.status == 'paused') && hasRoleEdit"
              class="dropdown item">
              <template>
                <button
                  v-if="posSession.status == 'selling'"
                  class="btn no-bg dropdown-toggle text-info"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="far fa-circle"/>
                  {{ $t('status.pos.selling') }}
                </button>
                <button
                  v-if="posSession.status == 'paused'"
                  class="btn no-bg dropdown-toggle text-warning"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="far fa-circle"/>
                  {{ $t('status.pos.paused') }}
                </button>
              </template>
              <div class="dropdown-menu dropdown-menu-right">
                <a
                  class="dropdown-item"
                  @click="closeSession(posSession.ps_id)">
                  <i
                    class="far fa-check-circle text-success"
                    style="position: relative; left: -7px;"/>
                  <span class="text-success">{{ $t('apps.pos.button.closesession') }}</span>
                </a>
              </div>
            </div>
            <!-- status message -->
            <template v-if="!hasRoleEdit">
              <div
                v-if="posSession.status == 'selling'"
                class="dropdown nodro item">
                <span class="text-info">
                  {{ $t('status.pos.selling') }}
                </span>
              </div>
              <div
                v-if="posSession.status == 'paused'"
                class="dropdown nodro item">
                <span class="text-warning">
                  {{ $t('status.pos.paused') }}
                </span>
              </div>
              <div
                v-if="posSession.status == 'closed'"
                class="dropdown nodro item">
                <span class="text-success">
                  {{ $t('status.pos.closed') }}
                </span>
              </div>
            </template>
            <!-- loading -->
            <div
              v-if="$store.state.app.loading"
              class="dropdown nodro item">
              <i class="fas fa-spinner spin"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="content col-md-12"
      style="background: var(--bg-grey-color);">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <div
        v-if="ready"
        class="col-md-12 no-padding"
        style="margin-top: 10px;">
        <div class="row no-margin dashboard">
          <div class="col-sm-12 col-lg-4 mb-3 item">
            <div class="outer">
              <div class="top">
                <i class="fas fa-clock"/>
              </div>
              <div class="middle">
                {{ getDurationFriendlyBySeconds(
                  (moment(posSession.ended_at || new Date).format('x') - moment(posSession.started_at).format('x')) / 1000,
                  $t,
                  false) }}
              </div>
              <div class="bottom">
                {{ $t('apps.pos.message.saledurationtime') }}
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-lg-4 mb-3 item">
            <div class="outer">
              <div class="top">
                <i class="fas fa-clipboard-list"/>
              </div>
              <div class="middle">
                {{ posSession.transactionInfo ? posSession.transactionInfo.count : 0 }}
              </div>
              <div class="bottom">
                {{ $t('apps.pos.message.transactions') }}
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-lg-4 mb-3 item">
            <div class="outer">
              <div class="top">
                <i class="fas fa-hand-holding-usd"/>
              </div>
              <div class="middle">
                {{ currencyFormatter(salesSummary.totalNet, { code: currency }) }}
              </div>
              <div class="bottom">
                {{ $t('message.nettotal') }}
              </div>
            </div>
          </div>
        </div>

        <table
          id="dataTable"
          class="table table-bordered"
          style="width: 100%;">
          <thead>
            <tr>
              <th class="text-center">{{ $t('message.date') }}</th>
              <th class="text-center">{{ $t('message.time') }}</th>
              <th class="text-center">#</th>
              <th>{{ $t('message.productlist') }}</th>
              <!-- <th>{{ $t('message.customer') }}</th> -->
              <!-- <th class="text-center">{{ $t('message.cashier') }}</th> -->
              <th
                class="text-right"
                style="min-width: 100px;">{{ $t('message.totaldiscount') }}</th>
              <th
                class="text-right"
                style="min-width: 100px;">{{ $t('message.totaltax') }}</th>
              <th
                class="text-right"
                style="min-width: 100px;">{{ $t('message.totalcollected') }}</th>
              <th
                class="text-right"
                style="min-width: 100px;">{{ $t('message.totalrefund') }}</th>
              <th
                class="text-right"
                style="min-width: 100px;">{{ $t('message.nettotal') }}</th>
              <th class="text-right"/>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(bill, index) in posSession.transactions"
              :class="[{
                'table-warning': bill.posbi_code == ref
              }]"
              :id="'ref-'+bill.posbi_code"
              :key="index"
            >
              <td class="text-center">
                {{ getDate(bill.created_at) }}
              </td>
              <td class="text-center">
                {{ getDateCustom(bill.created_at, {format: 'H:mm'}) }}
              </td>
              <td class="text-center">
                {{ bill.posbi_code }}
              </td>
              <td>
                <item-list
                  :orders="bill.orders"
                  :isShowPrice="true" />
              </td>
              <!-- <td>
                <router-link-custom :to="{name: 'ContactCustomerEdit', query: {cus_id: bill.customer.customer_id, cus_name: bill.customer.customer_name}}"
                                    :text="bill.customer.customer_name"
                                    :to_appid="11"
                                    :current_appid="1"
                                    :disabled="bill.customer.is_deleted == true"
                                    v-if="bill.customer" />
              </td> -->
              <!-- <td class="text-center">
                {{ bill.user.email || bill.user.username }}
              </td> -->
              <td class="text-right">
                {{ getNumber(getTotalPriceByItem(adjustModifiers(bill.orders)).discount) }}
              </td>
              <td class="text-right">
                {{ getNumber(getTotalPriceByItem(adjustModifiers(bill.orders)).tax) }}
              </td>
              <td class="text-right">
                {{ getNumber(bill.total) }}
              </td>
              <td
                :class="[{
                  'text-warning': getTotalRefunds(bill.refunds) > 0
                }]"
                class="text-right"
              >
                {{ getNumber(getTotalRefunds(bill.refunds)) }}
              </td>
              <td class="text-right">
                {{ getNumber(bill.total - getTotalRefunds(bill.refunds)) }}
              </td>
              <td class="text-center">
                <div class="dropdown">
                  <button
                    id="dropdownMenuButton"
                    class="btn no-bg dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <span class="name">
                      {{ $t('message.option') }}
                    </span>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="dropdownMenuButton">
                    <a
                      class="dropdown-item"
                      @click="detailModalOpen(bill)">
                      <i class="fas fa-info-circle"/>
                      {{ $t('apps.pos.message.transactiondetail') }}
                    </a>
                    <a
                      class="dropdown-item"
                      @click="onclickPrint(bill)">
                      <i class="fas fa-print"/>
                      {{ $t('message.printreceipt') }}
                    </a>
                    <a
                      v-if="hasRoleEdit"
                      class="dropdown-item"
                      @click="refundModalOpen(bill)">
                      <i class="fas fa-money-bill"/>
                      {{ $t('message.issuerefund') }}
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

    <div
      id="detailModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-md"
        role="document">
        <div
          v-if="billDetail"
          class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ psCode }}
              #{{ billDetail.posbi_code }}
            </h5>
          </div>
          <div class="modal-body">
            <section>
              <section-title
                :title="$t('message.detail')"
                fontweight="bold"/>
              <div style="padding: 15px;">
                <div class="row mb-3">
                  <div class="col-4">
                    {{ $t('message.date') }}
                  </div>
                  <div class="col">
                    {{ getDate(billDetail.created_at) }}
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-4">
                    {{ $t('message.time') }}
                  </div>
                  <div class="col">
                    {{ getDateCustom(billDetail.created_at, {format: 'H:mm'}) }}
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-4">
                    {{ $t('apps.pos.message.ordernumber') }}
                  </div>
                  <div class="col">
                    #{{ billDetail.posbi_code }}
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-4">
                    {{ $t('message.productlist') }}
                  </div>
                  <div class="col orders">
                    <item-list
                      :orders="billDetail.orders"
                      :isShowPrice="true "/>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-4">
                    {{ $t('message.totaldiscount') }}
                  </div>
                  <div class="col">
                    {{ getNumber(getTotalPriceByItem(adjustModifiers(billDetail.orders)).discount) }}
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-4">
                    {{ $t('message.totaltax') }}
                  </div>
                  <div class="col">
                    {{ getNumber(getTotalPriceByItem(adjustModifiers(billDetail.orders)).tax) }}
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-4">
                    {{ $t('message.totalcollected') }}
                  </div>
                  <div class="col">
                    {{ getNumber(billDetail.total) }}
                  </div>
                </div>
                <div
                  v-if="billDetail.refunds.length > 0"
                  class="row mb-3">
                  <div class="col-4">
                    {{ $t('message.totalrefund') }}
                  </div>
                  <div class="col">
                    <span
                      :class="getTotalRefunds(billDetail.refunds) > 0 ? 'text-warning': ''"
                    >
                      {{ getNumber(getTotalRefunds(billDetail.refunds)) }}
                    </span>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-4">
                    {{ $t('message.nettotal') }}
                  </div>
                  <div class="col">
                    {{ getNumber(billDetail.total - getTotalRefunds(billDetail.refunds)) }}
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-4">
                    {{ $t(`apps.pos.message.${billDetail.payment.type}`) }}
                  </div>
                  <div class="col">
                    <span>
                      {{ getNumber(billDetail.payment.amount) }}
                    </span>
                  </div>
                </div>
                <div
                  v-if="billDetail.payment.type === POS_PAYMENT_METHOD.CASH"
                  class="row mb-3"
                >
                  <div class="col-4">
                    {{ $t('message.cashchange') }}
                  </div>
                  <div class="col">
                    {{ getNumber(billDetail.payment.amount - billDetail.total) }}
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-4">
                    {{ $t('message.customer') }}
                  </div>
                  <div class="col">
                    <router-link-custom
                      v-if="billDetail.customer"
                      :to="{name: 'ContactCustomerEdit', query: {cus_id: billDetail.customer.customer_id, cus_name: billDetail.customer.customer_name}}"
                      :text="billDetail.customer.customer_name"
                      :to_appid="11"
                      :current_appid="1"
                      :disabled="billDetail.customer.is_deleted == true" />
                    <span
                      v-else>-</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    {{ $t('message.cashier') }}
                  </div>
                  <div class="col">
                    {{ billDetail.user.email || billDetail.user.username }}
                  </div>
                </div>
              </div>
            </section>
            <section
              v-if="billDetail.refunds.length > 0"
              class="pt-1">
              <section-title
                :title="$t('apps.pos.message.issuerefund')"
                fontweight="bold"/>
              <div
                v-for="(refund, index) in billDetail.refunds"
                :key="index"
                style="background: rgba(216, 226, 231, .25);margin-bottom: 10px;padding: 15px;"
              >
                <div class="row mb-3">
                  <div class="col-4">
                    {{ $t('apps.pos.message.issuerefundreason') }}
                  </div>
                  <div class="col">
                    <span v-if="refund.reason_id == null">
                      {{ refund.reason_custom }}
                    </span>
                    <span v-else>
                      {{ $t('apps.pos.message.issuerefundreason' + refund.reason_id) }}
                    </span>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-4">
                    {{ $t('message.date') }}
                  </div>
                  <div class="col">
                    {{ getDate(refund.created_at) }}
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-4">
                    {{ $t('message.time') }}
                  </div>
                  <div class="col">
                    {{ getDateCustom(refund.created_at, {format: 'H:mm'}) }}
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-4">
                    {{ $t('apps.pos.message.issuerefundamount') }}
                  </div>
                  <div class="col">
                    {{ getNumber(refund.amount) }}
                  </div>
                </div>
                <div
                  v-if="refund.orders.length > 0"
                  class="row mb-3">
                  <div class="col-4">
                    {{ $t('message.productlist') }}
                  </div>
                  <div class="col">
                    <span
                      v-for="(order, index) in refund.orders"
                      :key="index"
                      class="badge badge-secondary"
                      style="margin-right: 5px;"
                    >
                      <span>{{ getProductName(order.sku_id) }}</span>
                      <span v-if="order.quantity">x{{ order.quantity }}</span>
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    {{ $t('message.createdby') }}
                  </div>
                  <div class="col">
                    {{ refund.user.email || refund.user.username }}
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="detailModalClose()">{{ $t('button.close') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="refundModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-md"
        role="document">
        <div
          v-if="billDetail"
          class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $t('apps.pos.message.issuerefund') }}
            </h5>
          </div>
          <div class="modal-body">
            <section>
              <section-title :title="$t('apps.pos.message.issuerefundreason')"/>
              <select
                :class="refundValidate.reason_id"
                v-model="refund.reason_id"
                class="form-control custom-select"
              >
                <option
                  value=""
                  disabled>{{ $t('placeholder.select') }}</option>
                <option value="2">{{ $t('apps.pos.message.issuerefundreason2') }}</option>
                <option value="1">{{ $t('apps.pos.message.issuerefundreason1') }}</option>
                <option value="3">{{ $t('apps.pos.message.issuerefundreason3') }}</option>
                <option value="custom">{{ $t('message.custom') }}</option>
              </select>
              <input
                v-if="refund.reason_id == 'custom'"
                ref="custom-refund"
                :class="refundValidate.reason_custom"
                :placeholder="$t('message.message')"
                v-model="refund.reason_custom"
                type="text"
                class="form-control mt-2"
              >
            </section>
            <section v-if="refund.reason_id">
              <section-title :title="$t('message.productlist')"/>
              <div
                :class="[{'bordered-red': isShowRefundAmount == false}]"
                class="refund assign-items"
              >
                <div
                  v-for="(item, index) in mapItems"
                  :key="index"
                  :class="[{'active': item.active}]"
                  :style="[
                    { 'pointer-events': item.disabled ? 'none' : '' }
                  ]"
                  class="col-md-12 row align-items-center no-padding no-margin item"
                >
                  <div
                    :style="[
                      { 'opacity': item.disabled ? '0.2' : '1' },
                    ]"
                    class="col-12 no-margin row display"
                    @click="toggleAssign(index)"
                  >
                    <div
                      class="col-10"
                      style="padding-left: 10px;">
                      {{ item.name }}
                      <span class="badge badge-light">
                        {{ currencyFormatter(item.price, { code: currency }) }}
                      </span>
                    </div>
                    <div
                      class="col-2 text-right"
                      style="padding-right: 10px;">
                      <i
                        class="fas fa-check-circle"
                        style="color: #A3CA76;font-size: 15px;"/>
                      <i class="far fa-circle"/>
                    </div>
                  </div>
                  <div
                    v-if="item.active && hasStock(item.sku_id)"
                    class="col-12 no-margin row stock-return-input">
                    <div class="d-flex">
                      <vs-checkbox
                        :value="item.return_stock.active"
                        color="#A3CA76"
                        class="no-margin"
                        style="font-size: 12px;"
                        @change="toggleReturnStock(index)"
                      >
                        {{ $t('apps.pos.message.returnstock') }}
                      </vs-checkbox>
                    </div>
                    <template
                      v-if="item.return_stock.active"
                    >
                      <div>
                        <select
                          :class="`form-control custom-select ${!item.return_stock.wh_id && 'is-invalid'}`"
                          @change="selectReturnStockToWarehouse($event, index)"
                        >
                          <option
                            :value="-1"
                            :selected="!item.return_stock.wh_id"
                            disabled>
                            -- {{ $t('apps.inventory.message.selectwarehouse') }} --
                          </option>
                          <option
                            v-for="(warehouse, index) in warehouses.filter((wh) => hasStockIn(item.sku_id, wh.warehouse_id)).reduce((acc, cur) => {
                              const wh = cur

                              const isWhIdExist = acc.find((whItem) => whItem.wh_id === wh.warehouse_id)
                              if (!isWhIdExist) {
                                acc.push({
                                  text: `${getWarehouseNameById(wh.warehouse_id)}`,
                                  wh_id: wh.warehouse_id,
                                  bin_location_id: null,
                                })
                              }

                              if (wh.bin_locations.length > 0) {
                                wh.bin_locations.forEach((bin) => {
                                  acc.push({
                                    text: `${getWarehouseNameById(wh.warehouse_id)} - ${bin.code}`,
                                    wh_id: wh.warehouse_id,
                                    bin_location_id: bin._id,
                                  })
                                })
                              }
                              return acc
                            }, [])"
                            :key="index"
                            :value="`${warehouse.wh_id}-${warehouse.bin_location_id}`"
                          >
                            {{ warehouse.text }}
                          </option>
                        </select>
                      </div>
                      <div>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              {{ $t('apps.inventory.label.unit') }}
                            </span>
                          </div>
                          <input
                            :class="`form-control text-right number-only text-select-all ${parseFloat(item.return_stock.quantity) === 0 && 'is-invalid'}`"
                            v-model="item.return_stock.quantity"
                            type="text"
                            @keypress="numberOnly"
                            @keyup="item.return_stock.quantity = setToValidNumber(item.return_stock.quantity)"
                            @blur="item.return_stock.quantity = setToCustomDigitsNumber(item.return_stock.quantity)"
                          >
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div
                v-if="items.length > 1"
                style="font-size: 11px;color: #ccc;margin-top: 10px;"
              >
                {{ $t('apps.pos.message.chooseoneitempertime') }}
              </div>
            </section>
            <template v-if="isShowRefundAmount">
              <section>
                <section-title :title="$t('apps.pos.message.issuerefundamount')+' *'"/>
                <div class="form-row">
                  <div class="col-6">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ $t('message.totalrefund') }}</span>
                      </div>
                      <input
                        ref="amount-refund"
                        :class="refundValidate.amount"
                        v-model="refund.amount"
                        class="form-control text-select-all"
                        @keypress="numberOnly"
                        @keyup="refund.amount = setToValidNumber(refund.amount)"
                        @blur="refund.amount = setToCustomDigitsNumber(refund.amount)"
                      >
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i
                            class="fas fa-sync-alt"
                            style="margin-right: 5px;"/>
                          {{ $t('message.nettotal') }}
                        </span>
                      </div>
                      <input
                        :disabled="true"
                        :value="refund.newresult"
                        type="text"
                        class="form-control text-right"
                      >
                    </div>
                  </div>
                </div>
              </section>
            </template>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              class="btn btn-light btn-block-mobile-only"
              @click="refundModalClose()">{{ $t('button.close') }}</button>
            <button
              type="button"
              class="btn btn-web"
              @click="insertRefund()"
            >{{ $t('button.save') }}</button>
          </div>
          <div
            v-else
            class="modal-footer">
            <button
              class="btn btn-light btn-block-mobile-only"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              disabled><i class="fas fa-spinner spin"/></button>
          </div>
        </div>
      </div>
    </div>

    <receipt-view
      v-if="ready"
      :shop_logo="receiptInfoProps.shopLogo"
      :shop_name="receiptInfoProps.shopName"
      :shop_address="receiptInfoProps.shopAddress"
      :shop_tax_id="receiptInfoProps.shopTaxId"
      :shop_tax_title="receiptInfoProps.shopTaxTitle"
      :shop_tel="receiptInfoProps.shopTel"
      :orders="receiptInfoProps.orders"
      :total_price="receiptInfoProps.totalPrice"
      :receipt_info="receiptInfoProps.receiptInfo"
      :date_time="receiptInfoProps.dateTime"
      :text_footer="receiptInfoProps.textFooter"
      :font_size="receiptInfoProps.fontSize"
      class="receipt-template"
      style="position: fixed;z-index: -1;top: 1mm;left: 1mm;font-family: tahoma;color: black;width: 100%;"
    />

  </div>
</template>

<script>
import receiptView from '@/components/custom/print/pos/Receipt.vue'
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import _ from 'lodash'
import { POS_PAYMENT_METHOD, DOWNLOAD_EXTS, DOWNLOAD_EXT_VALUE } from '../../../../helpers/enum'
import userPermissionMixin from '@/mixins/userPermission'
import XLSX from 'xlsx'
import { getFileNameTransactionDetail } from '@/helpers/exportFormater'

export default {
  name: 'PosTransactionAll',
  components: {
    receiptView,
  },
  mixins: [userPermissionMixin],
  data () {
    return {
      POS_PAYMENT_METHOD: POS_PAYMENT_METHOD,
      DOWNLOAD_EXTS: DOWNLOAD_EXTS,

      ready: false,

      orders: [],
      totalPrice: {},
      receiptInfo: {},
      dateTime: '',

      billDetail: null,
      psCode: null,

      refund: {
        amount: 0,
        reason_id: '',
        reason_custom: '',
        newresult: 0,
      },
      refundValidate: {
        amount: null,
        reason_id: null,
        reason_custom: null,
      },
      items: [],
    }
  },
  computed: {
    ...mapGetters({
      sidebar: 'getSidebar',
      posSession: 'getPosSession',
      currency: 'getCurrency',
      getBillTotalPrice: 'getBillTotalPrice',
      getShopInfo: 'getShopInfo',
      warehouses: 'getWarehouses',
      getProductFullNameBySkuId: 'getProductFullNameBySkuId',
      getWarehouseInfo: 'getWarehouseInfo',
    }),
    getPosSales () {
      const data = this.posSession
      const transactions = data.transactions

      let totalQuantity = 0,
        totalCollected = 0,
        totalNet = 0,
        totalRefund = 0,
        totalVat = 0,
        productsCount = 0,
        totalCost = 0,
        discount = 0,
        totalProfit = 0,
        newCustomersCount = 0,
        oldCustomersCount = 0

      for (const transaction of transactions) {
        const orders = (() => {
          let cloneOrders = _.cloneDeep(transaction.orders)
          cloneOrders.map((order) => {
            let tempModifiers = order.modifiers
            order.modifiers = [{ options: [] }]
            tempModifiers.map((modi) => {
              order.modifiers[0].options.push(modi)
            })
          })
          return cloneOrders
        })()

        const getTotal = (() => {
          const result = (() => {
            const includeDiscount = true
            const includeTax = true
            const isRound = true
            const currency = 'THB'
            const round = (n) => {
              if (isRound) {
                return n
              }
              return Math.round(n)
            }
            const getResultPrice = (order) => {
              let result = order.price
              for (let m in order.modifiers) {
                for (let n in order.modifiers[m].options) {
                  let optionPrice = order.modifiers[m].options[n].price
                  result += optionPrice
                }
              }
              return result
            }
            const getResultPriceWithIncludedTax = (price, IncludedTaxRate = 0) => {
              return price * 100 / (100 + IncludedTaxRate)
            }

            var subTotalNumber = 0
            var discountNumber = 0
            var vatExcNumber = 0
            var vatIncNumber = 0 // vat inclusive
            var whtNumber = 0
            var totalNumber = 0
            var totalUntaxed = 0

            for (let i in orders) {
              let order = orders[i]
              var oPrice = getResultPrice(order) // order price included only modifiers
              var rPrice = oPrice * order.quantity // order price with discounts
              var rDiscount = 0 // discount amount of each order
              var rVatExc = 0 // vat exclusive of each order
              var rVatInc = 0 // vat inclusive of each order
              var rWht = 0 // withholding tax amount of each order
              var rUntaxed = 0 // untaxed amount of each order

              subTotalNumber += rPrice

              var tempDiscountPercent = 0 // tempDiscountPercent is not number but percentage such as 10%
              var tempDiscountNumber = 0 // tempDiscountNumber is not percentage but number such as 100 BATH

              if (includeDiscount) {
                for (let j in order.discounts) {
                  let discount = order.discounts[j]
                  const discountValueType = discount.value_type || discount.type
                  const discountValueAmount = discount.value_amount || discount.amount
                  if (discountValueType == 'percentage') {
                    tempDiscountPercent += discountValueAmount
                  } else if (discountValueType == 'number') {
                    tempDiscountNumber += discountValueAmount
                  }
                }
              }

              let discountA = tempDiscountPercent > 0 ? (oPrice - oPrice * ((100 - tempDiscountPercent) / 100)) : 0 // final discount of percent
              let discountB = tempDiscountNumber // final discount of number

              rDiscount += (discountA * order.quantity) + discountB
              rPrice -= rDiscount
              rUntaxed = rPrice
              discountNumber += rDiscount

              if (includeTax) {
                for (let k in order.taxes) {
                  let tax = order.taxes[k]
                  if (tax.type == 'include') {
                    let r = rUntaxed - getResultPriceWithIncludedTax(rUntaxed, tax.amount)
                    rVatInc = r
                    rUntaxed -= rVatInc
                  } else if (tax.type == 'exclude') {
                    if (tax.name == '{wht}') {
                      let r = rUntaxed * tax.amount / 100
                      rWht += r
                    } else {
                      let r = rUntaxed * tax.amount / 100
                      rVatExc += r
                    }
                  }
                }
              }

              vatExcNumber += rVatExc
              vatIncNumber += rVatInc
              whtNumber += rWht
              totalUntaxed += rUntaxed
            }

            totalNumber = subTotalNumber - discountNumber + vatExcNumber + whtNumber

            return {
              discount: parseFloat(currencyFormatter(round(discountNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
              taxes: {
                vat: {
                  exclusive: parseFloat(currencyFormatter(round(vatExcNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
                  inclusive: parseFloat(currencyFormatter(round(vatIncNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
                },
                wht: parseFloat(currencyFormatter(round(whtNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
                all: parseFloat(currencyFormatter(round(vatExcNumber) + vatIncNumber + whtNumber, { code: currency, symbol: '' }).replace(/,/g, '')),
              },
              untaxed: parseFloat(currencyFormatter(round(totalUntaxed), { code: currency, symbol: '' }).replace(/,/g, '')),
              sub: parseFloat(currencyFormatter(round(subTotalNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
              grand: parseFloat(currencyFormatter(round(totalNumber) - whtNumber, { code: currency, symbol: '' }).replace(/,/g, '')),
              payment: parseFloat(currencyFormatter(round(totalNumber), { code: currency, symbol: '' }).replace(/,/g, '')),
            }
          })()
          return {
            sub: result.sub,
            discount: result.discount,
            tax: result.taxes.vat.exclusive,
            total: result.payment,
          }
        })()

        productsCount += orders.reduce((total, order) => total + order.quantity, 0)
        totalCost += orders.reduce((total, order) => total + order.quantity * order.cost, 0)
        discount += getTotal.discount
        totalVat += getTotal.tax
        totalCollected += getTotal.total

        if (transaction.is_new_customer) {
          newCustomersCount += 1
        }

        if (!transaction.is_new_customer && transaction.customer) {
          oldCustomersCount += 1
        }

        for (const refund of transaction.refunds) {
          totalRefund += refund.amount
        }
      }

      totalNet = totalCollected - totalRefund
      totalProfit = totalNet - totalCost

      return {
        'cashier_id': data.user.user_id,
      	'ps_id': data.ps_id,
      	'ps_code': data.ps_code,
      	'transactions_count': data.transactions.length,
      	'products_count': productsCount,
      	'skus_count': productsCount,
      	'new_customers_count': newCustomersCount,
      	'old_customers_count': oldCustomersCount,
      	'cost': totalCost,
      	'discount': discount,
      	'tax': totalVat,
      	'collect': totalCollected,
      	'refund': totalRefund,
      	'net': totalNet,
      	'profit': totalProfit,
      }
    },
    salesSummary () {
      var totalQuantity = 0,
        totalCollected = 0,
        totalNet = 0,
        totalRefund = 0,
        totalVat = 0

      for (let i in this.posSession.transactions) {
        var orders = this.adjustModifiers(this.posSession.transactions[i].orders)

        var getTotal = this.getBillTotalPrice(orders, this.mixin)

        totalVat += getTotal.tax

        totalCollected += getTotal.total

        for (let j in this.posSession.transactions[i].refunds) {
          totalRefund += this.posSession.transactions[i].refunds[j].amount
        }
      }

      return {
        totalQuantity: totalQuantity,
        totalCollected: totalCollected,
        totalNet: totalCollected - totalRefund,
        totalVat: totalVat,
      }
    },
    ref () {
      return this.$route.query.ref
    },
    isShowRefundAmount () {
      var isSelectedAnyOrder = this.items.some((item) => item.active)
      return isSelectedAnyOrder
    },
    receiptInfoProps () {
      return {
        shopLogo: (() => {
          if (this.getShopInfo.settings.apps.pos.receipt.is_show_logo) {
            return this.getShopInfo.logo.thumbnail
          }
        })(),
        shopName: (() => {
          if (this.getShopInfo.settings.apps.pos.receipt.is_show_name) {
            return this.getShopInfo.shop_name
          }
        })(),
        shopAddress: (() => {
          if (this.getShopInfo.settings.apps.pos.receipt.is_show_address) {
            return this.getShopInfo.info.location.address
          }
        })(),
        shopTaxId: (() => {
          if (this.getShopInfo.settings.apps.pos.receipt.is_show_tax_id) {
            return this.getShopInfo.info.vat.taxpayer_no
          }
        })(),
        shopTaxTitle: this.getShopInfo.settings.apps.pos.receipt.is_show_tax_title,
        shopTel: (() => {
          if (this.getShopInfo.settings.apps.pos.receipt.is_show_tel) {
            const contact = this.getShopInfo.contacts.find((item) => item.platform === 'tel')
            return contact ? contact.source : ''
          }
        })(),
        orders: this.orders,
        totalPrice: this.totalPrice,
        receiptInfo: this.receiptInfo,
        textFooter: (() => {
          if (this.getShopInfo.settings.apps.pos.receipt.text_footer.is_active) {
            return this.getShopInfo.settings.apps.pos.receipt.text_footer.value
          }
        })(),
        fontSize: this.getShopInfo.settings.apps.pos.receipt.font_size,
        dateTime: this.dateTime,
      }
    },
    mapItems () {
      return this.items.map((item) => ({
        ...item,
        disabled: (() => {
          const activeItem = this.items.find((_item) => _item.active)
          if (activeItem && item.sku_id !== activeItem.sku_id) {
            return true
          }
          return false
        })(),
      }))
    },
  },
  methods: {
    ...mapActions([
      'getPosSession',
    ]),
    getTotalRefunds (refunds) {
      var amount = 0
      refunds.map(refund => {
        amount += refund.amount
      })
      return amount
    },
    async closeSession (ps_id) {
      // update
      let res = await this.$store.dispatch('updatePosMySessionStatus', {
        ps_id: ps_id,
        status: 'closed',
      })

      // set ready
      this.ready = false
      // get data
      await this.getPosSession({ ps_id: this.posSession.ps_id })

      // set ready
      this.ready = true
      // loading finish
      this.showFinish(this.$Progress)
    },
    adjustModifiers (orders) {
      let cloneOrders = _.cloneDeep(orders)
      cloneOrders.map(order => {
        let tempModifiers = order.modifiers
        order.modifiers = [{ options: [] }]
        tempModifiers.map(modi => {
          order.modifiers[0].options.push(modi)
        })
      })
      return cloneOrders
    },
    getTotalPriceByItem (orders) {
      return this.getBillTotalPrice(orders, this.mixin)
    },
    onclickPrint (bill) {
      this.orders = this.adjustModifiers(bill.orders)
      this.totalPrice = this.getTotalPriceByItem(this.orders)
      this.receiptInfo = {
        ps_code: this.posSession.ps_code,
        bi_code: bill.posbi_code,
        paymentMethod: bill.payment.type,
        customer: bill.customer,
        paid: bill.payment.amount,
        change: bill.payment.amount - this.totalPrice.total,
      }
      this.dateTime = this.moment(bill.created_at).format('H:mm')
      $('.receipt-template').printThis()
    },
    detailModalClose () {
      this.billDetail = null
      $('#detailModal').modal('hide')
    },
    detailModalOpen (bill) {
      this.billDetail = bill
      this.psCode = this.posSession.ps_code
      $('#detailModal').modal('show')
    },
    refundModalClose () {
      $('#refundModal').modal('hide')
    },
    async refundModalOpen (bill) {
      let total = bill.total - this.getTotalRefunds(bill.refunds)
      this.billDetail = bill
      this.refund.amount = this.setToCustomDigitsNumber(0)
      this.refund.reason_id = ''
      this.refund.reason_custom = ''
      this.setItems(bill.orders)
      $('#refundModal').modal('show')
    },
    setItems (orders) {
      this.items = []
      for (let i in orders) {
        let order = orders[i]
        var name = order.item + ' '
        if (order.modifiers.length > 0) name += '('
        order.modifiers.map((obj, idx) => {
          name += obj.option
          if (idx < order.modifiers.length - 1) {
            name += ', '
          }
        })
        if (order.modifiers.length > 0) name += ')'
        name += ' x' + order.quantity
        this.items.push({
          posbio_id: order.posbio_id,
          sku_id: order.sku_id,
          name: name,
          active: false,
          return_stock: {
            active: false,
            wh_id: null,
            bin_location_id: null,
            quantity: 0,
          },
          price: this.getPrice(order),
        })
      }
    },
    toggleAssign (index) {
      this.items[index].active = !this.items[index].active
    },
    toggleReturnStock (index) {
      this.items[index].return_stock.active = !this.items[index].return_stock.active
    },
    selectReturnStockToWarehouse (event, index) {
      const arr = event.target.value.split('-')
      const whId = arr[0]
      const binId = arr[1] == 'null' ? null : arr[1]

      this.items[index].return_stock.wh_id = whId
      this.items[index].return_stock.bin_location_id = binId
    },
    getPrice (order) {
      var orders = this.adjustModifiers([order])
      var getTotal = this.getBillTotalPrice(orders, this.mixin)
      return this.getNumber(getTotal.total)
    },
    isValidRefund () {
      let valid = true
      // reset
      this.refundValidate.amount = null
      this.refundValidate.reason_id = null
      this.refundValidate.reason_custom = null
      // check
      if (this.isShowRefundAmount) {
        if (parseFloat(this.refund.amount) === 0) {
          this.refundValidate.amount = 'is-invalid'
          this.$refs['amount-refund'].focus()
          valid = false
        }
      } else {
        this.refundValidate.amount = 'is-invalid'
        valid = false
      }
      if (this.refund.reason_id == '') {
        this.refundValidate.reason_id = 'is-invalid'
        valid = false
      }
      if (this.refund.reason_id == 'custom') {
        if (this.refund.reason_custom.trim().length == 0) {
          this.refundValidate.reason_custom = 'is-invalid'
          this.$refs['custom-refund'].focus()
          valid = false
        }
      }
      for (const item of this.items) {
        if (item.return_stock.active) {
          if (!item.return_stock.wh_id || item.return_stock.quantity === 0) {
            valid = false
            break
          }
        }
      }
      return valid
    },
    async insertRefund () {
      if (!this.isValidRefund()) {
        return
      }

      let bill = this.billDetail
      let refund = this.refund
      let reason_id = Number.isNaN(parseInt(refund.reason_id)) ? null : parseInt(refund.reason_id)
      let reason_custom = reason_id == null ? refund.reason_custom : null
      let orders = []

      this.items.map(obj => {
        if (obj.active) {
          orders.push({
            'posbio_id': obj.posbio_id,
            'sku_id': obj.sku_id,
            'return_stock': {
              'wh_id': obj.return_stock.active ? obj.return_stock.wh_id : null,
              'bin_location_id': obj.return_stock.active ? obj.return_stock.bin_location_id : null,
              'quantity': parseFloat(obj.return_stock.quantity),
            },
            'amount': parseFloat(refund.amount),
          })
        }
      })

      let dataSet = {
        'posbi_id': bill.posbi_id,
        'reason_id': reason_id,
        'reason_custom': reason_custom,
        'amount': parseFloat(refund.amount),
        'orders': orders,
      }

      let res = await this.$store.dispatch('insertPosBillRefund', dataSet)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.saved'),
          color: 'success',
          icon: 'cloud',
        })
        // close model
        this.refundModalClose()

        // set ready
        this.ready = false
        // get data
        await this.getPosSession({ ps_id: this.posSession.ps_id })
        // set ready
        this.ready = true

        // finish loading
        this.showFinish(this.$Progress)
      }
    },
    getProductName (sku_id) {
      let name = ''
      this.billDetail.orders.map(obj => {
        if (obj.sku_id == sku_id) {
          name = obj.item
        }
      })
      return name
    },
    hasStock (skuId) {
      for (const warehouse of this.warehouses) {
        for (const assignSku of warehouse.assign_skus) {
          if (assignSku.sku_id === skuId) {
            return true
          }
        }
      }
      return false
    },
    hasStockIn (skuId, whId) {
      for (const warehouse of this.warehouses) {
        if (warehouse.warehouse_id === whId) {
          for (const assignSku of warehouse.assign_skus) {
            if (assignSku.sku_id === skuId) {
              return true
            }
          }
        }
      }
      return false
    },
    async exportAs (fileType) {
      /* convert state to workbook */
      const headColumns = [
        this.$t('message.date'),
        this.$t('message.time'),
        '#',
        this.$t('message.productlist'),
        this.$t('message.quantity'),
        this.$t('message.unitprice'),
        this.$t('message.totaldiscount'),
        this.$t('message.totaltax'),
        this.$t('message.totalcollected'),
        this.$t('message.totalrefund'),
        this.$t('message.nettotal'),
      ]
      const bodyRows = this.posSession.transactions.reduce((acc, cur) => {
        const results = cur.orders.map((orderItem) => {
          const orderSummary = this.getTotalPriceByItem(this.adjustModifiers([orderItem]))
          const refunds = cur.refunds.reduce((_acc, _cur) => {
            const orders = _cur.orders.filter((_orderRefundItem) => _orderRefundItem.sku_id === orderItem.sku_id)
            if (orders.length) {
              _acc.push({
                ..._cur,
                orders,
              })
            }
            return _acc
          }, [])
          return [
            this.getDate(cur.created_at),
            this.getDateCustom(cur.created_at, { format: 'H:mm' }),
            cur.posbi_code,
            (() => {
              let str = this.getProductFullNameBySkuId(orderItem.sku_id)
              if (orderItem.modifiers && orderItem.modifiers.length) {
                str += ` (${orderItem.modifiers.map((v) => v.option).join(', ')})`
              }
              return str
            })(),
            orderItem.quantity,
            orderItem.price,
            orderSummary.discount,
            orderSummary.tax,
            orderSummary.total,
            this.getTotalRefunds(refunds),
            orderSummary.total - this.getTotalRefunds(refunds),
          ]
        })
        acc = [
          ...acc,
          ...results,
        ]
        return acc
      }, [])

      const data = [headColumns, ...bodyRows]
      const ws = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet')

      /* generate file and send to client */
      const fileName = getFileNameTransactionDetail(this.$t, fileType, this.posSession.ps_code)

      XLSX.writeFile(wb, fileName)
    },
    handleSelectDownload ({ value = null }) {
      if (value === DOWNLOAD_EXT_VALUE.EXCEL) {
        this.exportAs('xlsx')
      } else if (value === DOWNLOAD_EXT_VALUE.CSV) {
        this.exportAs('csv')
      }
    },
    getWarehouseNameById(whId) {
      return this.getWarehouseInfo(whId).warehouse_name
    },
  },
  watch: {
    ready: function () {
      // dataTable option
      let option = this.dataTableOption()
      option['searching'] = false
      option['paging'] = false
      option['info'] = false
      // set dataTable
      setTimeout(() => { $('#dataTable').DataTable(option) }, 1)
      // loading finish
      this.showFinish(this.$Progress)
    },
    'refund.reason_id': {
      handler: function (after) {
        let reason_id = after
        if (reason_id == 'custom') {
          this.$nextTick(() => {
            this.$refs['custom-refund'].focus()
          })
        }
        this.refund.reason_custom = ''
        this.refundValidate.reason_id = null
      },
      deep: true,
    },
    'refund.reason_custom': {
      handler: function (after) {
        let val = after.trim()
        if (val.length > 0) {
          this.refundValidate.reason_custom = null
        } else {
          this.refundValidate.reason_custom = 'is-invalid'
        }
      },
      deep: true,
    },
    'refund.amount': {
      handler: function (after) {
        let inputVal = parseFloat(after)
        let maxTotal = this.billDetail.total - this.getTotalRefunds(this.billDetail.refunds)
        if (inputVal > maxTotal) {
          this.refund.amount = maxTotal
        }
        let newresult = maxTotal - inputVal
        this.refund.newresult = Number.isNaN(newresult) ? '' : this.getNumber(newresult)
        // validate
        if (inputVal === 0) {
          this.refundValidate.amount = 'is-invalid'
        } else {
          this.refundValidate.amount = null
        }
      },
      deep: true,
    },
  },
  created: async function () {
    /**
     *  validation
     */
    if (!this.$route.query.ps_id) {
      return this.$router.push({ name: 'PosDashboard' })
    }

    // get data
    let res = await this.getPosSession({ ps_id: this.$route.query.ps_id })
    if (!res.success) {
      return this.$router.push({ name: 'PosDashboard' })
    }

    if (res.data.length == 0) {
      return this.$router.push({ name: 'PosDashboard' })
    }
    /**
     *  validation success
     */

    await this.$store.dispatch('getWarehouses')
    await this.$store.dispatch('getProducts')

    // set ready
    this.ready = true

    // scroll to dev if we have ref from url
    if (this.ref != undefined) {
      let that = this
      let _$ = $
      $(function () {
        let delay = 2000
        let refId = '#ref-' + that.ref
        let headerHeight = $('#header').outerHeight()
        let tabbarHeight = $('#content > .header').outerHeight()
        let theadHeight = $('#dataTable > thead').outerHeight()

        $('html, body').animate({ scrollTop: 0 }, 0)
        $('html, body').animate({
          scrollTop: $(refId).offset().top - headerHeight - tabbarHeight - theadHeight,
        }, delay)

        setTimeout(() => {
          let fixedHeaderHeight = _$('.fixedHeader-floating').outerHeight()
          if (fixedHeaderHeight) {
            _$('html, body').animate({
              scrollTop: $(refId).offset().top - headerHeight - tabbarHeight - fixedHeaderHeight + 2,
            }, 500)
          }
        }, delay)
      })
    }
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.pos.title'),
      current: {
        app_name: 'pos',
        app_id: 1,
        module_id: 2,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 2, [{
      'name': this.$route.query.ps_code,
      'router': {
        'name': 'PosTransactionDetail',
        'query': {
          ps_id: this.$route.query.ps_id,
          ps_code: this.$route.query.ps_code,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 2,
      submenuAtIdx: 1,
    })
  },
  mounted: function () {
    // set popup modal
    this.setModal('#detailModal')
    this.setModal('#refundModal')
  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearPosSession'])
  },
}
</script>

<style scoped>
  .dashboard {
    width: -webkit-calc(100% + 15px);
  	width:    -moz-calc(100% + 15px);
  	width:         calc(100% + 15px);
  }
  .dashboard .item {
    padding-left: 0;
  }
  .dashboard .item .outer {
    background: var(--bg-color);
    padding: 15px 15px 10px 15px;
  }
  .dashboard .item .outer .top {
    position: relative;
    top: -5px;
    height: 25px;
    font-size: 26px;
    text-align: right;
    color: rgba(255,255,255,.38);
  }
  .dashboard .item .outer .middle {
    text-align: center;
    font-size: 26px;
    color: var(--link-color-dark);
  }
  .dashboard .item .outer .bottom {
    text-align: center;
    font-size: 15px;
    color: var(--link-color-dark);
  }
  .bordered-red {
    box-shadow: 0 0 0 1px #ea848d;
  }
  /* .bordered-red .item:first-of-type {
    border-top: 1px solid #ea848d;
    border-left: 1px solid #ea848d;
    border-right: 1px solid #ea848d;
  }
  .bordered-red .item:last-of-type {
    border-bottom: 1px solid #ea848d;
    border-left: 1px solid #ea848d;
    border-right: 1px solid #ea848d;
  } */
  #detailModal .modal-body section:last-of-type {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/transaction/Detail.vue